var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4932 5.62666C27.3383 5.50135 27.1573 5.41236 26.9635 5.36621C26.7697 5.32006 26.568 5.31794 26.3732 5.35999L15.9999 7.69332L5.62658 5.33333C5.42875 5.28864 5.22333 5.28968 5.02596 5.33637C4.82859 5.38305 4.64446 5.47414 4.48761 5.60271C4.33075 5.73128 4.20529 5.89394 4.12078 6.07831C4.03627 6.26268 3.99493 6.4639 3.99991 6.66666V22.9333C3.99238 23.2415 4.09189 23.5428 4.28151 23.7859C4.47113 24.029 4.73914 24.1989 5.03991 24.2667L15.7066 26.6667H16.2932L26.9599 24.2667C27.2607 24.1989 27.5287 24.029 27.7183 23.7859C27.9079 23.5428 28.0074 23.2415 27.9999 22.9333V6.66666C27.999 6.46638 27.953 6.26889 27.8652 6.08885C27.7775 5.9088 27.6504 5.75083 27.4932 5.62666ZM6.66658 8.33332L14.6666 10.1333V23.6667L6.66658 21.8667V8.33332ZM25.3332 21.8667L17.3332 23.6667V10.1333L25.3332 8.33332V21.8667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookOpen);
export default __webpack_public_path__ + "static/media/book-open.9ff05f4f.svg";
export { ForwardRef as ReactComponent };